<template>
    <div class="container-fluid search_cinci-module bg-black py-5">
        <div class="row">
            <div class="container">
                <div class="row d-block d-sm-block d-md-block d-lg-none">
                    <div class="col-12">
                        <div class="global-header text-center">
                            <h2>{{paneldata.heading}}</h2>
                            <div class="module-content" v-html="paneldata.content"></div>
                        </div>
                    </div>
                </div>
                <div class="row sliders">
                    <div class="col-md-5 col-lg-5">
                        <div class="image-wrap glide glide-image" style="height: 100%">
                            <div class="glide__track" data-glide-el="track" style="height: 100%">
                                <ul class="glide__slides mb-md-0" style="height: 100%;">
                                    <li class="glide__slide" v-for="(item, index) of topicsdata" :key="'image_' + item.title + '_' + index">
                                        <img :src="item.image.url" :alt="item.title" v-if="item.image.url" />
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-7 col-lg-7 content-wrap">
                        <div class="global-header d-none d-sm-none d-md-none d-lg-block">
                            <h2>{{paneldata.heading}}</h2>
                            <div class="module-content" v-html="paneldata.content"></div>
                        </div>
                        <div class="glide glide-content">
                            <div class="slider-content bg-plum mt-0 mt-sm-0 mt-md-4 mt-lg-5 p-3 glide__track" data-glide-el="track">
                                <ul class="glide__slides mb-md-0">
                                    <li class="glide__slide slide" :key="'content_' + item.title + '_' + index" v-for="(item, index) of topicsdata">
                                        <h3>{{item.title}}</h3>
                                        <div class="content" v-html="item.excerpt"></div> 
                                        <a class="btn btn-primary bg-mauve d-none d-sm-none d-md-inline-block" :href="item.url">Explore {{item.title}}</a>
                                        <a class="d-inline d-sm-inline d-md-none" :href="item.url">Explore {{item.title}}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="glide-arrows d-none d-md-flex flex-row justify-content-start mt-3">
                            <button id="prev" class="prev d-flex flex-row justify-content-center align-items-center mr-3">
                                <svg width="36px" height="21px" viewBox="0 0 24 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <title>Previous Arrow</title>
                                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <g id="homepage" transform="translate(-639.000000, -1367.000000)" fill="#FFFFFF" fill-rule="nonzero">
                                            <g id="Arrow-to-left-by-Icons-Bazaar-from-the-Noun-Project" transform="translate(639.000000, 1367.000000)">
                                                <g id="Group" transform="translate(0.000000, 0.170825)">
                                                    <path d="M6.92163043,0.088631687 C6.80272343,0.0992956367 6.6907857,0.149373042 6.60358696,0.230914296 L0.17576087,6.12308821 C0.0633038102,6.22465908 -0.000874988537,6.36910631 -0.000874988537,6.52064256 C-0.000874988537,6.6721788 0.0633038102,6.81662603 0.17576087,6.9181969 L6.60358696,12.8103708 C6.74547197,12.9399304 6.94582879,12.9836808 7.1288056,12.9250589 C7.31178241,12.8664371 7.44941382,12.7144024 7.48959483,12.5265127 C7.52977585,12.338623 7.46636537,12.1435947 7.32336957,12.0152621 L1.91663043,7.06047951 L23.0330435,7.06047951 C23.3160352,7.0644969 23.5770652,6.80783917 23.5770652,6.52482734 C23.5770652,6.24181551 23.3160352,5.98518456 23.0330435,5.98917517 L1.91663043,5.98917517 L7.32336957,1.02602299 C7.49879856,0.87327778 7.55561094,0.624778214 7.4639822,0.410977824 C7.37235346,0.197177434 7.15322455,0.0669384219 6.92163043,0.088631687 Z" id="Path"></path>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </button>
                            <div id="next" class="next d-flex flex-row justify-content-center align-items-center">
                                <svg width="36px" height="21px" viewBox="0 0 24 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <title>Next Story</title>
                                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <g id="homepage" transform="translate(-639.000000, -1367.000000)" fill="#FFFFFF" fill-rule="nonzero">
                                            <g id="Arrow-to-left-by-Icons-Bazaar-from-the-Noun-Project" transform="translate(639.000000, 1367.000000)">
                                                <g id="Group" transform="translate(0.000000, 0.170825)">
                                                    <path d="M6.92163043,0.088631687 C6.80272343,0.0992956367 6.6907857,0.149373042 6.60358696,0.230914296 L0.17576087,6.12308821 C0.0633038102,6.22465908 -0.000874988537,6.36910631 -0.000874988537,6.52064256 C-0.000874988537,6.6721788 0.0633038102,6.81662603 0.17576087,6.9181969 L6.60358696,12.8103708 C6.74547197,12.9399304 6.94582879,12.9836808 7.1288056,12.9250589 C7.31178241,12.8664371 7.44941382,12.7144024 7.48959483,12.5265127 C7.52977585,12.338623 7.46636537,12.1435947 7.32336957,12.0152621 L1.91663043,7.06047951 L23.0330435,7.06047951 C23.3160352,7.0644969 23.5770652,6.80783917 23.5770652,6.52482734 C23.5770652,6.24181551 23.3160352,5.98518456 23.0330435,5.98917517 L1.91663043,5.98917517 L7.32336957,1.02602299 C7.49879856,0.87327778 7.55561094,0.624778214 7.4639822,0.410977824 C7.37235346,0.197177434 7.15322455,0.0669384219 6.92163043,0.088631687 Z" id="Path"></path>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row d-flex d-sm-flex d-md-none">
                    <div class="col-12">
                        <div class="glide-arrows d-flex flex-row justify-content-center mt-3">
                            <button id="mobileprev" class="prev d-flex flex-row justify-content-center align-items-center mr-3">
                                <svg width="36px" height="21px" viewBox="0 0 24 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <title>Previous Story</title>
                                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <g id="homepage" transform="translate(-639.000000, -1367.000000)" fill="#FFFFFF" fill-rule="nonzero">
                                            <g id="Arrow-to-left-by-Icons-Bazaar-from-the-Noun-Project" transform="translate(639.000000, 1367.000000)">
                                                <g id="Group" transform="translate(0.000000, 0.170825)">
                                                    <path d="M6.92163043,0.088631687 C6.80272343,0.0992956367 6.6907857,0.149373042 6.60358696,0.230914296 L0.17576087,6.12308821 C0.0633038102,6.22465908 -0.000874988537,6.36910631 -0.000874988537,6.52064256 C-0.000874988537,6.6721788 0.0633038102,6.81662603 0.17576087,6.9181969 L6.60358696,12.8103708 C6.74547197,12.9399304 6.94582879,12.9836808 7.1288056,12.9250589 C7.31178241,12.8664371 7.44941382,12.7144024 7.48959483,12.5265127 C7.52977585,12.338623 7.46636537,12.1435947 7.32336957,12.0152621 L1.91663043,7.06047951 L23.0330435,7.06047951 C23.3160352,7.0644969 23.5770652,6.80783917 23.5770652,6.52482734 C23.5770652,6.24181551 23.3160352,5.98518456 23.0330435,5.98917517 L1.91663043,5.98917517 L7.32336957,1.02602299 C7.49879856,0.87327778 7.55561094,0.624778214 7.4639822,0.410977824 C7.37235346,0.197177434 7.15322455,0.0669384219 6.92163043,0.088631687 Z" id="Path"></path>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </button>
                            <button id="mobilenext" class="next d-flex flex-row justify-content-center align-items-center">
                                <svg width="36px" height="21px" viewBox="0 0 24 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <title>Next Story</title>
                                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <g id="homepage" transform="translate(-639.000000, -1367.000000)" fill="#FFFFFF" fill-rule="nonzero">
                                            <g id="Arrow-to-left-by-Icons-Bazaar-from-the-Noun-Project" transform="translate(639.000000, 1367.000000)">
                                                <g id="Group" transform="translate(0.000000, 0.170825)">
                                                    <path d="M6.92163043,0.088631687 C6.80272343,0.0992956367 6.6907857,0.149373042 6.60358696,0.230914296 L0.17576087,6.12308821 C0.0633038102,6.22465908 -0.000874988537,6.36910631 -0.000874988537,6.52064256 C-0.000874988537,6.6721788 0.0633038102,6.81662603 0.17576087,6.9181969 L6.60358696,12.8103708 C6.74547197,12.9399304 6.94582879,12.9836808 7.1288056,12.9250589 C7.31178241,12.8664371 7.44941382,12.7144024 7.48959483,12.5265127 C7.52977585,12.338623 7.46636537,12.1435947 7.32336957,12.0152621 L1.91663043,7.06047951 L23.0330435,7.06047951 C23.3160352,7.0644969 23.5770652,6.80783917 23.5770652,6.52482734 C23.5770652,6.24181551 23.3160352,5.98518456 23.0330435,5.98917517 L1.91663043,5.98917517 L7.32336957,1.02602299 C7.49879856,0.87327778 7.55561094,0.624778214 7.4639822,0.410977824 C7.37235346,0.197177434 7.15322455,0.0669384219 6.92163043,0.088631687 Z" id="Path"></path>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row topics_shelf mt-3 mt-sm-3 mt-md-5">
                    <div class="col-12">
                        <div class="topics d-flex flex-row flex-wrap justify-content-start" data-glide-el="controls[nav]">
                            <a
                                class="topic w-25 mt-3"
                                v-for="(item, index) in topicsdata"
                                :href="item.url"
                                :key="item.title"
                                :data-index="index"
                                :data-glide-dir="'=' + index"
                            >
                                <img class="topic-thumb" :src="item.thumbnail" alt="Topic Thumbnail" />
                                <span class="topic-title mt-1">{{item.title}}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
@import "../../../node_modules/bootstrap/scss/_functions.scss";
@import "../../../node_modules/bootstrap/scss/mixins.scss";
@import "../../scss/config/bootstrap.scss";

// fade animation for glide
.glide__slides {transform:none !important; width:auto !important; display:block;}
.glide__slide {position:absolute; left:0; top:0; opacity:0; transition:opacity 1s;}
.glide__slide:first-child {position:relative;}
.glide__slide--active {z-index:1; opacity:1;}

.search_cinci-module {
    .sliders {
        .image-wrap {
            position: relative;
            img {
                border-left: 40px solid $plum;
                border-bottom: 40px solid $plum;
            }
            &:before {
                content: "";
                position: absolute;
                z-index: 400;
                top: 0;
                left: 0;
                display: block;
                width: 40px;
                height: 40px;
                background: $black;
            }
            &:after {
                content: "";
                position: absolute;
                z-index: 400;
                bottom: 0;
                right: 0;
                display: block;
                width: 40px;
                height: 40px;
                background: $black;
            }
            .glide__slides {
                margin: 0;
                .glide__slide {
                }
            }
        }
        .content-wrap {
            .glide-content {
                .slider-content {
                    .glide__slides {
                        margin: 0;
                        .glide__slide {
                            width: auto!important;
                        }
                    }
                }
            }
    
        }
    }
    .glide-arrows {
        .prev, .next {
            width: 40px;
            height: 40px;
            background: transparent;
            border: none;
            &:hover {
                cursor: pointer;
            }
        }
        .prev {

        }
        .next {
            transform: rotate(180deg);
        }
    }
    .topics_shelf {
        .topics {
            border-top:  1px solid $grey;
            .topic {
                text-decoration: none;
                padding: 0 15px;
                border: none;
                background: none;
                img.topic-thumb {
                    display: block;
                }
                span.topic-title {
                    text-align: left;
                    text-transform: uppercase;
                    font-size: 12px;
                    color: $white;
                    display: block;
                    
                }
                &:hover {
                    span.topic-title {
                        color: $tequila;
                    }
                }
            }
        }
    }
}


@include media-breakpoint-down(sm) {
    .search_cinci-module {
        .sliders {
            // - 0 Margins to remove gutters
            margin-right: 0 !important;
            margin-left: 0 !important;
            > [class*="col-"] {
                padding-right: 0;
                padding-left: 0;
            }
            .image-wrap {
                img {
                    border-left: none;
                    border-bottom: none;
                }
                &:before {
                    display: none;
                    width: 0px;
                    height: 0px;
                    background: transparent;
                }
                &:after {
                    display: block;
                    width: 0px;
                    height: 0px;
                    background: transparent;
                }
            }

            .content-wrap {
                .glide-content {
                    height: 100%;
                    .slider-content {
                        height: 100%;
                        .glide__slides {
                            .glide__slide {
                                h3 {
                                    font-size: 18px;
                                    font-weight: bold;
                                }
                                .content {
                                    font-size: 16px;
                                }
                                .btn {
                                    font-size: 14px;
                                    padding: 0.5rem;
                                    min-width: initial;
                                }
                            }
                        }
                    }
                }
            }
        }
        .topics_shelf {
            .topics {
                .topic {
                    width: 50% !important;
                    &:nth-child(odd) {
                        padding-left: 0;
                        padding-right: 7.5px;
                    }
                    &:nth-child(even) {
                        padding-left: 7.5px;
                        padding-right: 0;
                    }
                    img.topic-thumb {
                    }
                    span.topic-title {
                    }
                    &:hover {
                        span.topic-title {
                        }
                    }
                }
            }
        }
         .glide-arrows {
                .prev, .next {
                   padding: 0;
                }
            }
    }
}

</style>
<script>

import Glide from "@glidejs/glide";
export default {
  props: {
    topicsdata: {
        type: Array|Object
    },
    paneldata: {
        type: Array|Object
    }
  },
  data() {
    return {};
  },
  computed: {
  },
  methods: {
    mountSlider() {
        const imageSliderElement = this.$el.querySelector('.glide-image');
        const contentSliderElement = this.$el.querySelector('.glide-content');

        const imageSlider = new Glide(imageSliderElement, {
            type: 'slider',
            perView: 1,
            startAt: 0,
            autoplay: 7000,
            hoverpause: false,
            gap: 0
        }).mount();

        const contentSlider = new Glide(contentSliderElement, {
            type: 'slider',
            perView: 1,
            startAt: 0,
            autoplay: 7000,
            hoverpause: false,
            gap: 0
        }).mount();
        
        // let navItem = document.getElementsByClassName('glide__bullet');
        let prevBtn = document.getElementById('prev');
        let nextBtn = document.getElementById('next');
        let mobileprevBtn = document.getElementById('mobileprev');
        let mobilenextBtn = document.getElementById('mobilenext');
        
        prevBtn.addEventListener('click', () => {
            contentSlider.go('<');
            imageSlider.go('<');
        });
        nextBtn.addEventListener('click', () => {
            contentSlider.go('>');
            imageSlider.go('>');
        });
        mobileprevBtn.addEventListener('click', () => {
            contentSlider.go('<');
            imageSlider.go('<');
        });
        mobilenextBtn.addEventListener('click', () => {
            contentSlider.go('>');
            imageSlider.go('>');
        });
        // Array.from(navItem).forEach(item => {
            
        //     item.addEventListener('click',() => {
        //         let index = item.getAttribute('data-index');
        //         console.log('='+ index);
        //         contentSlider.go('='+ index);
        //         imageSlider.go('='+ index);
        //     });
        // });


    },
  },
  created() {},
  mounted() {
      this.mountSlider();
  }
};
</script>
